<template>
    <div class="default">
        <Header v-if="!loading" />
        <div class="default__content-wrapper">
            <KLoader v-if="loading" />
            <RouterView v-if="!loading" class="page-inner" :key="router.currentRoute.value.fullPath" />
        </div>
        <Footer />
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core';
import router from '@/router';
import { useUserStore } from '@/stores/user';
import UserApi from '@/api/v1/UserApi';
import { toast } from 'vue3-toastify';
import { navigateTo } from '@/hooks/NavigateHooks';
import { ROLE_ID_ADMIN_WHOLESALER } from '@/hooks/UserHooks';
import Header from './components/Header.vue';
import KLoader from '@/components/atoms/KLoader.vue';
import Footer from '@/views/Layout/components/Footer.vue';

const loading = ref<boolean>(false);
const { logoutUser, setUserInfo } = useUserStore();
const userApi = new UserApi();
const user = async() => {
    loading.value = true;
    try {
        const result = await userApi.user();
        if (!result.isSuccess) {
            await router.push('/');
            await logoutUser();
            toast.error(t('auth.toast.errorGetUser'));
            loading.value = false;
            return;
        }
        if (result.payload.role === ROLE_ID_ADMIN_WHOLESALER) {
            navigateTo(`/warehouse/details/${result.payload.wholesaler_ids[0]}`);
        }
        await setUserInfo(result.payload);
    } catch (e) {
        await router.push('/');
        await logoutUser();
        toast.error(t('auth.toast.errorGetUser'));
        loading.value = false;
        return;
    }
    loading.value = false;
};
user();
</script>

<style scoped lang="scss">
.default {
    position: relative;

    &__content-wrapper {
        min-height: 100vh;
    }
}
</style>
